module.exports = __webpack_public_path__ + "img/logo.74b66c62.png";